import { JSONObject } from 'src/types/utility';

/**
 * Serialize a POJO for use in
 * application/x-www-form-urlencoded calls.
 */
export default (obj?: JSONObject): string => {
  if (!obj) {
    return '';
  }

  const s: string[] = [];

  Object.keys(obj).forEach(key => {
    const val = obj[key];

    if (val && Array.isArray(val)) {
      val.forEach(v => {
        s.push(`${key}=${encodeURIComponent(String(v))}`);
      });
    } else {
      s.push(`${key}=${encodeURIComponent(String(val))}`);
    }
  });

  return s.join('&');
};
